/* eslint-disable max-len */
import React from 'react';
import classnames from 'classnames';
import { Text, Flex, Button } from '@leverege/ui-elements';
import I18N from '@leverege/i18n';
import S from './TwoFactorOneTimeCodes.css';
const {
  t
} = I18N.ns('login.TwoFactorOneTimeCodes');
export default function TwoFactorOneTimeCodes(props) {
  const {
    oneTimeCodes,
    onNext,
    nextButtonVariant,
    loading,
    LoadingComponent
  } = props;
  return /*#__PURE__*/React.createElement(Flex, {
    variant: "colM"
  }, /*#__PURE__*/React.createElement(Text, {
    variant: "twoStepTitle|title"
  }, t('title')), /*#__PURE__*/React.createElement(Text, null, t('subtitle')), /*#__PURE__*/React.createElement(Flex, {
    justify: "space-between",
    align: "center",
    className: classnames(S.cardSection, S.codes)
  }, /*#__PURE__*/React.createElement(Flex, {
    style: {
      flexWrap: 'wrap'
    }
  }, Object.keys(oneTimeCodes).map((code, index) => {
    return /*#__PURE__*/React.createElement("div", {
      key: code,
      className: S.code
    }, index + 1, ". ", code);
  }))), /*#__PURE__*/React.createElement(Button, {
    onClick: onNext,
    style: {
      marginTop: 10
    },
    variant: nextButtonVariant
  }, loading ? /*#__PURE__*/React.createElement(LoadingComponent, null) : t('proceedText')));
}